import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles(() => ({
  chips: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '4px',
  },

  chip: {
    height: '20px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  renderer: {
    width: '100%',
    whiteSpace: 'normal',
    lineHeight: '22px',
    paddingInline: '2pt',
    minHeight: '1lh',
  },
}));
